const getEnsemblTranscripts = (state) =>
  state && state.variantResult && state.variantResult.ensembl_transcripts;
export { getEnsemblTranscripts };
